import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Construction, ArrowLeft } from "lucide-react";

/**
 * 「準備中」ページ共通パネル。
 * 未実装メニューを開いたときに、公開予定である旨とダッシュボードへの戻り導線を示す。
 */
export default function ComingSoonPanel({
    title,
    description,
}: {
    title: string;
    description: React.ReactNode;
}) {
    const navigate = useNavigate();
    const location = useLocation();
    const basePrefix = location.pathname.startsWith("/demo") ? "/demo" : "/app";

    return (
        <div className="mx-auto max-w-3xl rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
            <div className="flex items-start gap-3">
                <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-slate-100">
                    <Construction size={18} className="text-slate-500" aria-hidden="true" />
                </span>
                <div className="min-w-0">
                    <div className="flex flex-wrap items-center gap-2">
                        <h2 className="text-lg font-bold text-slate-800">{title}</h2>
                        <span className="inline-flex items-center rounded-full border border-slate-200 bg-slate-100 px-2 py-0.5 text-[11px] font-semibold text-slate-600">
                            準備中
                        </span>
                    </div>
                    <p className="mt-2 text-sm text-slate-600">{description}</p>
                    <p className="mt-1 text-sm text-slate-500">
                        こちらの機能は公開予定です。今しばらくお待ちください。
                    </p>

                    <button
                        type="button"
                        onClick={() => navigate(`${basePrefix}/dashboard`)}
                        className="mt-4 inline-flex items-center gap-1.5 rounded-md border border-slate-300 bg-white px-3 py-1.5 text-sm text-slate-700 hover:bg-slate-50"
                    >
                        <ArrowLeft size={16} aria-hidden="true" />
                        ダッシュボードへ戻る
                    </button>
                </div>
            </div>
        </div>
    );
}
